const ROOTS = {
  AUTH: '/auth',
  DASHBOARD: '/dashboard',
};

export const paths = {
  page403: '/error/403',
  page404: '/error/404',
  page500: '/error/500',
  // AUTH
  auth: {
    jwt: {
      signIn: `${ROOTS.AUTH}/jwt/sign-in`,
      signUp: `${ROOTS.AUTH}/jwt/sign-up`,
      forgotPassword: `${ROOTS.AUTH}/jwt/forgot-password`,
    }
  },
  // DASHBOARD
  dashboard: {
    root: ROOTS.DASHBOARD,
    analytics: `${ROOTS.DASHBOARD}/analytics`,
    permission: `${ROOTS.DASHBOARD}/permission`,
    general: {
      booking: `${ROOTS.DASHBOARD}/booking`,
    },
    account: {
      root: `${ROOTS.DASHBOARD}/account`,
      profile: `${ROOTS.DASHBOARD}/account/profile`,
      settings: `${ROOTS.DASHBOARD}/account/settings`,
    },
    users: {
      root: `${ROOTS.DASHBOARD}/users`,
      list: `${ROOTS.DASHBOARD}/users`,
      profile: `${ROOTS.DASHBOARD}/users/profile`,
      account: `${ROOTS.DASHBOARD}/users/account`,
      details: (id) => `${ROOTS.DASHBOARD}/users/${id}`,
      edit: (id) => `${ROOTS.DASHBOARD}/users/${id}/edit`,
    },
    // Pickle Loop specific paths
    clubs: {
      root: `${ROOTS.DASHBOARD}/clubs`,
      new: `${ROOTS.DASHBOARD}/clubs/new`,
      list: `${ROOTS.DASHBOARD}/clubs`,
      details: (id) => `${ROOTS.DASHBOARD}/clubs/${id}`,
      edit: (id) => `${ROOTS.DASHBOARD}/clubs/${id}/edit`,
    },
    facilities: {
      root: `${ROOTS.DASHBOARD}/facilities`,
      new: `${ROOTS.DASHBOARD}/facilities/new`,
      list: `${ROOTS.DASHBOARD}/facilities`,
      details: (id) => `${ROOTS.DASHBOARD}/facilities/${id}`,
      edit: (id) => `${ROOTS.DASHBOARD}/facilities/${id}/edit`,
      availability: (id) => `${ROOTS.DASHBOARD}/facilities/${id}/availability`,
      unavailability: (id) => `${ROOTS.DASHBOARD}/facilities/${id}/unavailability`,
    },
    sessions: {
      root: `${ROOTS.DASHBOARD}/sessions`,
      new: `${ROOTS.DASHBOARD}/sessions/new`,
      list: `${ROOTS.DASHBOARD}/sessions`,
      details: (id) => `${ROOTS.DASHBOARD}/sessions/${id}`,
      edit: (id) => `${ROOTS.DASHBOARD}/sessions/${id}/edit`,
      courtLineup: (id) => `${ROOTS.DASHBOARD}/sessions/${id}/court-lineup`,
      players: (id) => `${ROOTS.DASHBOARD}/sessions/${id}/players`,
      facilities: (id) => `${ROOTS.DASHBOARD}/sessions/${id}/facilities`,
      recurring: {
        root: `${ROOTS.DASHBOARD}/sessions/recurring`,
        new: `${ROOTS.DASHBOARD}/sessions/recurring/new`,
        list: `${ROOTS.DASHBOARD}/sessions/recurring`,
        details: (id) => `${ROOTS.DASHBOARD}/sessions/recurring/${id}`,
        edit: (id) => `${ROOTS.DASHBOARD}/sessions/recurring/${id}/edit`,
      }
    },
    matches: {
      root: `${ROOTS.DASHBOARD}/matches`,
      list: `${ROOTS.DASHBOARD}/matches`,
      details: (id) => `${ROOTS.DASHBOARD}/matches/${id}`,
      edit: (id) => `${ROOTS.DASHBOARD}/matches/${id}/edit`,
      players: (id) => `${ROOTS.DASHBOARD}/matches/${id}/players`,
    },
    leaderboard: {
      root: `${ROOTS.DASHBOARD}/leaderboard`,
      global: `${ROOTS.DASHBOARD}/leaderboard?scope=global`,
      local: `${ROOTS.DASHBOARD}/leaderboard?scope=local`,
      details: (id) => `${ROOTS.DASHBOARD}/leaderboard/${id}`,
      recalc: `${ROOTS.DASHBOARD}/leaderboard/recalc`,
    },
    payments: {
      root: `${ROOTS.DASHBOARD}/payments`,
      list: `${ROOTS.DASHBOARD}/payments`,
      details: (id) => `${ROOTS.DASHBOARD}/payments/${id}`,
      refunds: `${ROOTS.DASHBOARD}/payments/refunds`,
      reports: `${ROOTS.DASHBOARD}/payments/reports`,
    },
    wallet: {
      root: `${ROOTS.DASHBOARD}/wallet`,
      list: `${ROOTS.DASHBOARD}/wallet`,
    },
    vouchers: {
      root: `${ROOTS.DASHBOARD}/vouchers`,
      list: `${ROOTS.DASHBOARD}/vouchers`,
      new: `${ROOTS.DASHBOARD}/vouchers/new`,
      details: (id) => `${ROOTS.DASHBOARD}/vouchers/${id}`,
      edit: (id) => `${ROOTS.DASHBOARD}/vouchers/${id}/edit`,
      redeem: `${ROOTS.DASHBOARD}/vouchers/redeem`,
      redemptions: `${ROOTS.DASHBOARD}/vouchers/redemptions`,
    },
    auditLogs: {
      root: `${ROOTS.DASHBOARD}/audit-logs`,
      list: `${ROOTS.DASHBOARD}/audit-logs`,
      details: (id) => `${ROOTS.DASHBOARD}/audit-logs/${id}`,
      export: `${ROOTS.DASHBOARD}/audit-logs/export.csv`,
    },
    appVersions: {
      root: `${ROOTS.DASHBOARD}/app-versions`,
      new: `${ROOTS.DASHBOARD}/app-versions/new`,
      list: `${ROOTS.DASHBOARD}/app-versions`,
      details: (id) => `${ROOTS.DASHBOARD}/app-versions/${id}`,
      edit: (id) => `${ROOTS.DASHBOARD}/app-versions/${id}/edit`,
    },
    settings: {
      root: `${ROOTS.DASHBOARD}/settings`,
      maintenance: `${ROOTS.DASHBOARD}/settings/maintenance`,
      health: `${ROOTS.DASHBOARD}/settings/health`,
    },
    banners: {
      root: `${ROOTS.DASHBOARD}/banners`,
      new: `${ROOTS.DASHBOARD}/banners/new`,
      list: `${ROOTS.DASHBOARD}/banners`,
      details: (id) => `${ROOTS.DASHBOARD}/banners/${id}`,
      edit: (id) => `${ROOTS.DASHBOARD}/banners/${id}/edit`,
    },
    permissions: {
      root: `${ROOTS.DASHBOARD}/permissions`,
    },
    reports: {
      root: `${ROOTS.DASHBOARD}/reports`,
      userActivity: `${ROOTS.DASHBOARD}/reports/user-activity`,
      clubPerformance: `${ROOTS.DASHBOARD}/reports/club-performance`,
      revenueAnalytics: `${ROOTS.DASHBOARD}/reports/revenue-analytics`,
      systemUsage: `${ROOTS.DASHBOARD}/reports/system-usage`,
    },
    bookings: {
      root: `${ROOTS.DASHBOARD}/bookings`,
      new: `${ROOTS.DASHBOARD}/bookings/new`,
      list: `${ROOTS.DASHBOARD}/bookings`,
      details: (id) => `${ROOTS.DASHBOARD}/bookings/${id}`,
      edit: (id) => `${ROOTS.DASHBOARD}/bookings/${id}/edit`,
    },
    // Manager Module - Admin side
    managers: {
      root: `${ROOTS.DASHBOARD}/admin/managers`,
      new: `${ROOTS.DASHBOARD}/admin/managers/new`,
      list: `${ROOTS.DASHBOARD}/admin/managers`,
      details: (id) => `${ROOTS.DASHBOARD}/admin/managers/${id}`,
      edit: (id) => `${ROOTS.DASHBOARD}/admin/managers/${id}/edit`,
    },
    // Facility Owner Module - Admin side
    facilityOwners: {
      root: `${ROOTS.DASHBOARD}/admin/facility-owners`,
      new: `${ROOTS.DASHBOARD}/admin/facility-owners/new`,
      list: `${ROOTS.DASHBOARD}/admin/facility-owners`,
      details: (id) => `${ROOTS.DASHBOARD}/admin/facility-owners/${id}`,
      edit: (id) => `${ROOTS.DASHBOARD}/admin/facility-owners/${id}/edit`,
    },
    // Help Desk
    feedback: {
      root: `${ROOTS.DASHBOARD}/feedback`,
      list: `${ROOTS.DASHBOARD}/feedback`,
      details: (id) => `${ROOTS.DASHBOARD}/feedback/${id}`,
    },
    support: {
      root: `${ROOTS.DASHBOARD}/support`,
      list: `${ROOTS.DASHBOARD}/support`,
      new: `${ROOTS.DASHBOARD}/support/new`,
      details: (id) => `${ROOTS.DASHBOARD}/support/${id}`,
      edit: (id) => `${ROOTS.DASHBOARD}/support/${id}/edit`,
    },
    bugs: {
      root: `${ROOTS.DASHBOARD}/bugs`,
      list: `${ROOTS.DASHBOARD}/bugs`,
      new: `${ROOTS.DASHBOARD}/bugs/new`,
      details: (id) => `${ROOTS.DASHBOARD}/bugs/${id}`,
      edit: (id) => `${ROOTS.DASHBOARD}/bugs/${id}/edit`,
    },
    chat: {
      root: `${ROOTS.DASHBOARD}/chat`,
    },
    openPlay: {
      root: `${ROOTS.DASHBOARD}/open-play`,
      board: `${ROOTS.DASHBOARD}/open-play?tab=board`,
      queue: `${ROOTS.DASHBOARD}/open-play?tab=queue`,
      waiting: `${ROOTS.DASHBOARD}/open-play?tab=waiting`,
      session: (id) => `${ROOTS.DASHBOARD}/open-play?tab=board&session=${id}`,
    },
    monitors: {
      root: `${ROOTS.DASHBOARD}/monitors`,
      new: `${ROOTS.DASHBOARD}/monitors/new`,
      list: `${ROOTS.DASHBOARD}/monitors`,
      details: (id) => `${ROOTS.DASHBOARD}/monitors/${id}`,
      edit: (id) => `${ROOTS.DASHBOARD}/monitors/${id}/edit`,
    },
    ads: {
      root: `${ROOTS.DASHBOARD}/ads`,
      new: `${ROOTS.DASHBOARD}/ads/new`,
      list: `${ROOTS.DASHBOARD}/ads`,
      details: (id) => `${ROOTS.DASHBOARD}/ads/${id}`,
      edit: (id) => `${ROOTS.DASHBOARD}/ads/${id}/edit`,
      playlists: {
        root: `${ROOTS.DASHBOARD}/ads/playlists`,
        new: `${ROOTS.DASHBOARD}/ads/playlists/new`,
        list: `${ROOTS.DASHBOARD}/ads/playlists`,
        details: (id) => `${ROOTS.DASHBOARD}/ads/playlists/${id}`,
        edit: (id) => `${ROOTS.DASHBOARD}/ads/playlists/${id}/edit`,
      },
      schedules: {
        root: `${ROOTS.DASHBOARD}/ads/schedules`,
        new: `${ROOTS.DASHBOARD}/ads/schedules/new`,
        list: `${ROOTS.DASHBOARD}/ads/schedules`,
        edit: (id) => `${ROOTS.DASHBOARD}/ads/schedules/${id}/edit`,
      },
    },
  },
  // Manager Console - Manager side
  manager: {
    root: '/manager',
    dashboard: '/manager',
    facilities: '/manager/facilities',
    sessions: '/manager/sessions',
    bookings: '/manager/bookings',
    reports: '/manager/reports',
  },
};
